// ink-component
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import getGlobalProps from '../../../../helpers/constants/global-props';

import NavItemElement from '../../../_common/NavItemElement/NavItemElement';

export interface HorizontalNavAnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Modifier to highlight the active item */
  active?: boolean;
}

const globalProps = getGlobalProps({});

/**
 * @purpose An anchor element used inside HorizontalNav
 * @group HorizontalNav
 * @categories navigation
 * @HTMLType HTMLAnchorElement
 */
const HorizontalNavAnchor = (props: HorizontalNavAnchorProps) => {
  const { style, className, active, children, ...otherProps } = props;
  const currentTheme = useContext(ThemeContext);

  const theme = { ...currentTheme, active };

  return (
    <NavItemElement as="a" theme={theme} tabIndex={0} {...otherProps} {...globalProps}>
      {children}
    </NavItemElement>
  );
};

HorizontalNavAnchor.defaultProps = {
  active: false,
};

HorizontalNavAnchor.displayName = 'HorizontalNav.Anchor';

export default HorizontalNavAnchor;
